<template>
    <div>
        <supa-base-header-sec class="mb-0"></supa-base-header-sec>
        <supa-advanced-search-base-header-sec></supa-advanced-search-base-header-sec>
        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <b-form @submit.stop.prevent="onSubmit" v-on:keyup.enter="search" @reset="onReset">
                    <div class="row">

                        <div class="col-md-4">

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Врста билтена</label>
                                <select v-model="biltenType" class="form-control full-width">
                                    <option value="-1">Све врсте билтена</option>
                                    <option v-for="option in biltenTypes" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Број билтена</label>
                                <select v-model="biltenIssue" class="form-control full-width">
                                    <option value="-1">Сви бројеви билтена</option>
                                    <option v-for="option in biltenIssues" v-bind:key="option.podatak"
                                        :value="option.podatak">
                                        {{ option.podatak }}
                                    </option>
                                </select>
                            </b-form-group>

                        </div>

                        <div class="col-md-4">
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Речи и изрази у називу</label>
                                <input id="titleQuery" v-model="titleQuery" type="text" class="form-control full-width">
                            </b-form-group>
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Речи и изрази у тексту</label>
                                <input id="bodyQuery" v-model="bodyQuery" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Врста суда</label>
                                <select v-model="courtType" class="form-control full-width">
                                    <option value="-1">Све остале врсте судова</option>
                                    <option v-for="option in courtTypes" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm" v-if="courts.length > 0">
                                <label class="form-label">Суд</label>
                                <select v-model="court" class="form-control full-width">
                                    <option value="-1">Сви судови</option>
                                    <option v-for="option in courts" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm" v-if="departments.length > 0">
                                <label class="form-label">Судско одељење</label>
                                <select v-model="department" class="form-control full-width">
                                    <option value="-1">Сва одељења</option>
                                    <option v-for="option in departments" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Уписник</label>
                                <select v-model="upisnik" class="form-control full-width" :disabled="upisnici.length == 0">
                                    <option value="-1" v-if="upisnici.length > 0">Сви уписници</option>
                                    <option v-for="option in upisnici" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Ознака и број акта </label>
                                <input v-model="actId" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Садржи</label>
                                <select v-model="contentType" class="form-control full-width">
                                    <option v-for="option in contentTypes" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group v-if="contentSubtypes.length > 0" class="form-group-sm">
                                <label class="form-label">Подврста садржаја</label>
                                <select v-model="contentSubtype" class="form-control full-width">
                                    <option v-for="option in contentSubtypes" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                        </div>

                        <div class="col-md-4">

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Пропис битан за пресуђење</label>
                                <input v-model="essRule" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Чланови</label>
                                <input v-model="articles" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Релевантно право</label>
                                <input v-model="relLaw" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Правна област</label>
                                <select v-model="legalAreaId" class="form-control full-width">
                                    <option value="-1" selected="selected">Све правне области</option>
                                    <option v-for="option in legalAreas" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Правна материја</label>
                                <select v-model="legalSubjectId" class="form-control full-width">
                                    <option value="-1" selected="selected">Све правне материје</option>
                                    <option v-for="option in legalSubjects" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm" v-if="legalSubsubjects.length > 0">
                                <label class="form-label">Правна подматерија</label>
                                <select v-model="legalSubsubjectId" class="form-control full-width">
                                    <option value="-1" selected="selected">Све правне подматерије</option>
                                    <option v-for="option in legalSubsubjects" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <!--                            <b-form-group class="form-group-sm">-->
                            <!--                                <label class="form-label">Датум од</label>-->
                            <!--                                <datepicker-->
                            <!--                                        v-model="dateFrom"-->
                            <!--                                        :full-month-name="true"-->
                            <!--                                        format="dd.MM.yyyy"-->
                            <!--                                        input-class="form-control full-width"-->
                            <!--                                        :calendar-button="true"-->
                            <!--                                        calendar-button-icon="icon-calendar1"-->
                            <!--                                        :clear-button="true"-->
                            <!--                                        :disabledDates="disabledDatesFrom"-->
                            <!--                                        clear-button-icon="icon-x"-->
                            <!--                                        :bootstrap-styling="true" :language="srCYRL">-->
                            <!--                                </datepicker>-->
                            <!--                            </b-form-group>-->
                            <!--                            <b-form-group class="form-group-sm">-->
                            <!--                                <label class="form-label">Датум до</label>-->
                            <!--                                <datepicker-->
                            <!--                                        v-model="dateTo"-->
                            <!--                                        :full-month-name="true"-->
                            <!--                                        format="dd.MM.yyyy"-->
                            <!--                                        input-class="form-control full-width"-->
                            <!--                                        :calendar-button="true"-->
                            <!--                                        calendar-button-icon="icon-calendar1"-->
                            <!--                                        :clear-button="true"-->
                            <!--                                        :disabledDates="disabledDatesTo"-->
                            <!--                                        clear-button-icon="icon-x"-->
                            <!--                                        :bootstrap-styling="true" :language="srCYRL">-->
                            <!--                                </datepicker>-->
                            <!--                            </b-form-group>-->

                            <data-picker-mask-component ref="dataPickerMask" @datapiskerDateFromValue="emitedDateFrom"
                                @datapiskerDateToValue="emitedDateTo"></data-picker-mask-component>

                        </div>
                    </div>

                    <div class="spacer20"></div>

                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm ">
                            <div class="form-inline ">
                                <label for="resultLimit" class="form-label mr-2">Величина резултата</label>
                                <select id="resultLimit" v-model="resultLimit" class="form-control">
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="300">300</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group form-group-sm ">
                            <b-button type="button" @click="search" class="btn btn-base-submit text-uppercase mr-3" v-if="canOpen === 'can_open'">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <b-button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <b-button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'role_not_allowed'" href="#" @click.stop.prevent="role_not_allowed()">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <b-button type="reset" class="btn btn-base-reset text-uppercase mr-3">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </b-button>
                            <b-button type="button" class="btn btn-base-reset text-uppercase" @click="copyQuery"
                                v-if="canCopyQuery" style="margin: 5px 0 0 0;">
                                <span class="icon-copy mr-2"></span>
                                Kopiraj upit
                            </b-button>
                        </div>
                    </div>
                </b-form>
            </div>

            <result-counter :count="resultSize" :limit="limit"></result-counter>

            <div class="base-box base-box__table-sec" v-if="result.length > 0">

                <b-table class="table-bootstrap-vue" striped bordered :items="result" :fields="fields"
                    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" responsive="sm">
                    <template v-slot:cell(subjectId)="data">
                        <router-link target="_blank" :to="{ path: '/supa/viewAct/' + data.item.id }">{{
                            data.item.subjectId
                        }}</router-link>
                    </template>
                    <template v-slot:cell(name)="data">
                        <router-link target="_blank" :to="{ path: '/supa/viewAct/' + data.item.id }">{{
                            data.item.name
                        }}</router-link>
                    </template>
                    <template v-slot:cell(timestamp)="data">
                        {{ data.item.date }}
                    </template>
                </b-table>


            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import SupaBaseHeaderSec from '@/base_pages/supa/SupaBaseHeaderSec.vue';
import SupaAdvancedSearchBaseHeaderSec from '@/base_pages/supa/SupaAdvancedSearchBaseHeaderSec.vue';
// import Datepicker from 'vuejs-datepicker';
// import {SortedTable, SortLink} from "vue-sorted-table";
import { srCYRL } from 'vuejs-datepicker/dist/locale'
import ResultCounter from '@/partials/ResultCounter.vue';

import DataPickerMaskComponent from '@/components/DataPickerMaskComponent.vue';
import { mapState } from 'vuex';


export default {
    name: "SupaAdvancedSearchOcSearchPage",
    data() {
        return {
            limit: 50,
            sortBy: 'timestamp',
            sortDesc: true,
            fields: [
                { label: 'Назив суда', key: 'courtName', sortable: true },
                { label: 'Ознака и број предмета', key: 'subjectId', sortable: true },
                { label: 'Датум доношења', key: 'timestamp', sortable: true },
                { label: 'Ближе одређење материје / назив', key: 'name', sortable: true },
                { label: 'Начин објављивања', key: 'issuer', sortable: true },
                { label: 'Број и страна', key: 'issuePage', sortable: true },

            ],
            emitedDateFromVal: null,
            emitedDateToVal: null,
            srCYRL: srCYRL,
            baseDIApiUrl:window.env.VUE_APP_API_DI_DEV,
            baseSPApiUrl: window.env.VUE_APP_API_SP_DEV,
            resultSize: null,
            result: [],
            courtType: -1,
            contentType: -1,
            contentSubtype: -1,
            court: -1,
            department: -1,
            upisnik: -1,
            biltenIssue: -1,
            biltenType: -1,
            legalAreaId: -1,
            legalSubjectId: -1,
            legalSubsubjectId: -1,
            publishingMethod: -1,
            actId: null,
            titleQuery: null,
            bodyQuery: null,
            essRule: null,
            articles: null,
            relLaw: null,
            dateFrom: null,
            dateTo: null,

            resultLimit: 50,

            lastChanged: '', // bilten_type | court_type

            // Collections
            biltenTypes: [],
            courtTypes: [],
            legalAreas: [],
            legalSubjects: [],

            allBiltenTypes: [],
            allCourtTypes: [],

            courts: [],
            departments: [],
            upisnici: [],
            contentTypes: [],
            contentSubtypes: [],
            legalSubsubjects: [],
            resultLimitOptions: [],
            biltenIssues: [],

            contentTypeQueries: [],
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        SupaBaseHeaderSec,
        SupaAdvancedSearchBaseHeaderSec,
        // Datepicker,
        // SortedTable,
        // SortLink,
        ResultCounter,
        DataPickerMaskComponent
    },
    computed: {
        ...mapState(['userInfoState']),
        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes('SP')) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
        canCopyQuery() {
            if (this.userInfoState && this.searchResult !== null) {
                return this.userInfoState.roles.includes('INTERNAL_USER');
            } return false;
        },
        disabledDatesFrom: function () {
            if (this.dateTo === null) {
                return { from: new Date }
            } else return { from: this.dateTo }
        },
        disabledDatesTo: function () {
            if (this.dateFrom === null) {
                return { from: new Date }
            } else return { to: this.dateFrom, from: new Date }
        }
    },
    methods: {
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        emitedDateFrom(e) {
            this.emitedDateFromVal = e;
        },
        emitedDateTo(e) {
            this.emitedDateToVal = e;
        },
        fetchFilterData: function () {
            axios.get(this.baseSPApiUrl + 'prins/biltenSearch/filter')
                .then(response => {
                    // this.limit = response.data.limit; 
                    this.courtTypes = this.allCourtTypes = response.data.courtTypes;
                    this.biltenTypes = this.allBiltenTypes = response.data.biltenTypes;
                    this.biltenIssues = response.data.biltenNumbers;
                    this.legalAreas = response.data.legalAreas;
                    this.legalSubjects = response.data.legalSubjects;
                });
            axios.get(this.baseSPApiUrl + 'Prins/sadrzi/4')
                .then(response => {
                    this.contentTypes = response.data;
                    for (var i = 1; i < this.contentTypes.length; i++) {
                        this.contentTypeQueries[this.contentTypes[i].k] = this.contentTypes[i].query;
                    }
                });
        },
        copyQuery() {
            var data = {
                act: (this.actId == '') ? null : this.actId,
                bk: (this.bodyQuery == '') ? null : this.bodyQuery,
                tk: (this.titleQuery == '') ? null : this.titleQuery,
                limit: this.resultLimit,
                essRule: (this.essRule == '') ? null : this.essRule,
                articles: (this.articles == '') ? null : this.articles,
                relLaw: (this.relLaw == '') ? null : this.relLaw,
                other: (this.contentType == 3),
                desc: (this.contentType == 1),
                resp: (this.contentType == 2),
                sent: (this.contentType == 0),
                up: (this.upisnici.length > 0) ? this.upisnik : null,
                opid: (this.contentType == 1) ? this.contentSubtype : -1,
                spid: (this.contentType == 0) ? this.contentSubtype : -1,
                pspid: this.contentSubtype,
                lega: this.legalAreaId,
                legs: this.legalSubjectId,
                legss: (this.legalSubjectId > 0) ? this.legalSubsubjectId : null,
                bn: (this.biltenIssue != -1) ? this.biltenIssue : null,
                bt: this.biltenType,
                ct: this.courtType,
                df: this.emitedDateFromVal,
                dt: this.emitedDateToVal,
            }

            var el = document.createElement('textarea');
            el.value = JSON.stringify({
                path: 'api/supa/biltenSearch',
                payload: data
            });

            el.style.dislay = 'none';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);

            alert('Upit je kopiran u clipboard');
        },
        search: function () {

            // Local DATA
            // let responseLocal = {"limit":50,"resultSize":4669,"result":[{"htmlUuid":"48a166cf-f5b0-edba-9145-02da2fc59f54","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж2 332/18","name":"Кривично процесно право - мера забране напуштања стана","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-126","date":"31.05.2018","year":null},{"htmlUuid":"c51b776a-8fa8-e102-fe00-b4a6d612b069","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж2 318/18","name":"Кривично процесно право - немогућност измене оптужнице након наступања апсолутне застарелости кривичног гоњења","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-115","date":"25.05.2018","year":null},{"htmlUuid":"0ab488b3-1388-31a2-00e8-7abce458b6ec","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж1 497/18","name":"Изрицање васпитних мера","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-109","date":"22.05.2018","year":null},{"htmlUuid":"f031881d-6d40-e16c-bc0c-6569f5df5a43","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж1 482/18","name":"Кривично процесно право - битна повреда одредаба кривичног поступка из члана 438. став 2. тачка 2. ЗКП-а","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-132","date":"17.05.2018","year":null},{"htmlUuid":"3e89e588-0d3a-4a22-3332-135125529857","courtName":"Апелациони суд у Крагујевцу","subjectId":"Гж1 1292/18","name":"Примена критеријума у поступку измене уговорених услова рада","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-180","date":"08.05.2018","year":null},{"htmlUuid":"8bc28df7-b22e-b9a1-e2e1-f64d7076cb77","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж-уо 75/18","name":"Кривично процесно право - условни отпуст","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-137","date":"17.04.2018","year":null},{"htmlUuid":"73681416-5cce-38c6-41e7-f696f9044fb6","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж1 131/18","name":"Кривичн материјално право - кривично дело злостављање и мучење (члан 137. КЗ)","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-105","date":"13.04.2018","year":null},{"htmlUuid":"cd69d97f-69e0-8c07-7de3-40e772b8f3fe","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж1 304/18","name":"Кривично материјално право - изрицање кривичне санкције у ситуацији када је кривично гоњење преузето од стране државе","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-101","date":"13.04.2018","year":null},{"htmlUuid":"b5dc48aa-4e25-4e0d-4565-89639aafe982","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж2 173/18","name":"Кривично процесно право - потврђивање оптужнице","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-114","date":"22.03.2018","year":null},{"htmlUuid":"37197238-ce8b-1a56-f2fa-f9bb19059f89","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж1 107/18","name":"Кривично прoцесно право - члан 450. став 5. Законика о кривичном поступку","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-133","date":"20.03.2018","year":null},{"htmlUuid":"91a66063-35c7-8929-f0ac-afb569322e60","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж2 152/18","name":"Кривично процесно право - повраћај у пређашње стање оштећеног као тужиоца због пропуштања рока за подношење ванредног правног лека","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-122","date":"15.03.2018","year":null},{"htmlUuid":"128b200f-3103-e124-808d-dedd2c9e8b5e","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж1 266/18","name":"Кривично материјално право - оружје за личну безбедност (члан 3. тачка 1. Закона о оружју и муницији)","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-110","date":"12.03.2018","year":null},{"htmlUuid":"cd647e9a-17da-8edb-51a2-34cacaf8b796","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж2 24/18","name":"Кривично материјално право - повреда кривичног закона","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-104","date":"12.01.2018","year":null},{"htmlUuid":"5cce4378-6f23-923b-6a8e-be2826ec932d","courtName":"Апелациони суд у Крагујевцу","subjectId":"Гж 1369/17","name":"Стварно право - савесност као битан елеменат за стицање права својине на непокретностима","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-154","date":"07.05.2018","year":null},{"htmlUuid":"c5a0d9aa-7d91-f528-f165-19c7d019e098","courtName":"Апелациони суд у Крагујевцу","subjectId":"Гж1 2514/17","name":"Радње које суд може да предузима за време трајања прекида поступка","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-201","date":"03.04.2018","year":null},{"htmlUuid":"4b7a6591-c374-431d-67f2-41c72fdfc1f7","courtName":"Апелациони суд у Крагујевцу","subjectId":"Гж 2963/17","name":"Стварно право - фиктиван правни посао и стицања права својине одржајем","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-162","date":"22.03.2018","year":null},{"htmlUuid":"a64f6f9f-190f-23c1-6074-0d8e418b8193","courtName":"Апелациони суд у Крагујевцу","subjectId":"Гж1 2830/17","name":"Право на јубиларну награду и неретроактивност дејства општег акта","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-203","date":"09.03.2018","year":null},{"htmlUuid":"c62ade30-1317-9ff1-d9b3-4ef475ceb445","courtName":"Апелациони суд у Крагујевцу","subjectId":"Гж 4502/17","name":"Повреда права прече куповине","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-155","date":"06.03.2018","year":null},{"htmlUuid":"2e1bb103-ec8a-d24c-98b6-75e1d50219de","courtName":"Апелациони суд у Крагујевцу","subjectId":"Гж 1949/17","name":"Парнични поступак - битна повреда одредбе парничног поступка (члан 374. став 2. тачка 7. ЗПП)","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-148","date":"19.02.2018","year":null},{"htmlUuid":"b2c7715d-67d5-e0cb-5eac-4f5951fa19f8","courtName":"Врховни касациони суд","subjectId":"Рев2 1740/17","name":"Право запосленог на увећану зараду по основу времена проведеног на раду","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-178","date":"07.02.2018","year":null},{"htmlUuid":"52a75945-0820-aeeb-5473-e54e527919d3","courtName":"Апелациони суд у Крагујевцу","subjectId":"Гж1 967/17","name":"Доспелост новчане накнаде за лица на стручном оспособљавању и усавршавању","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-191","date":"31.01.2018","year":null},{"htmlUuid":"9977a7da-6cf6-975c-d6c6-097401f41ef1","courtName":"Апелациони суд у Крагујевцу","subjectId":"Гж1 3411/17","name":"Право запосленог на накнаду трошкова за време проведено на службеном путу у иностранству","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-179","date":"22.12.2017","year":null},{"htmlUuid":"473dbedb-4693-1dbe-781a-8ba1eb8f30b8","courtName":"Уставни суд","subjectId":"IУо 279/2016","name":"Оцена уставности и законитости Одлуке о утврђивању својства осигураника и обавези плаћања доприноса за пензијско и инвалидско осигурање - непостојање овлашћења Републичког фонда за пензијско и инвалидско осигурање да својим актом уређује питање утврђивања доприноса ван случајева када утврђује својство осигураника","issuer":"Билтен Уставног суда","issuePage":"01/2017-273","date":"21.12.2017","year":null},{"htmlUuid":"29264d8c-d379-f08e-bf7b-c19acbe9cec5","courtName":"Апелациони суд у Крагујевцу","subjectId":"Гж1 1161/17","name":"Међусобни однос два решења којима је запосленом отказан исти уговор о раду и њихов утицај на законитост одлуке о престанку радног односа","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-194","date":"19.12.2017","year":null},{"htmlUuid":"32373026-525e-9512-7ec5-d690372694f0","courtName":"Врховни касациони суд","subjectId":"Рев2 1147/17","name":"Понављање поступка","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-199","date":"07.12.2017","year":null},{"htmlUuid":"a720f0af-e870-3389-a664-b73cbbb8e004","courtName":"Апелациони суд у Крагујевцу","subjectId":"Р4 р 11/17","name":"Одлучивање о приговору без испитног поступка","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-169","date":"28.11.2017","year":null},{"htmlUuid":"2e5ba9b8-6ec1-4e15-9062-dc0df5733191","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж2 613/17","name":"Кривично процесно право - немогућност подношења приватне тужбе након одбацивања кривичне пријаве за кривична дела за која се гони по службеној дужности","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-131","date":"30.10.2017","year":null},{"htmlUuid":"4817dbf6-94bd-8e00-c1c7-a0e6e1bff579","courtName":"Апелациони суд у Новом Саду","subjectId":"Кж-уо 282/17","name":"Кривично материјално право - примена тзв. \"Маријиног закона\", у односу на институт условног отпуста","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-077","date":"27.10.2017","year":null},{"htmlUuid":"052e5390-4675-3f81-5deb-2a89a1171641","courtName":"Апелациони суд у Новом Саду","subjectId":"Кж2 1168/17","name":"Кривично материјално право - примена члана 4. став 1. Закона о амнестији","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-077","date":"27.10.2017","year":null},{"htmlUuid":"0fb39736-f404-a66f-6262-69ef2c5b4da5","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж2 623/17","name":"Кривично процесно право - приговор оштећеног","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-121","date":"26.10.2017","year":null},{"htmlUuid":"89aa308e-a339-c117-43b5-2f3b3dcc0e80","courtName":"Виши суд у Новом Саду","subjectId":"Гж рр 25/17","name":"Суђење у разумном року - повреда права на суђење у разумном року","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-063","date":"25.10.2017","year":null},{"htmlUuid":"9425d359-12ad-a3ee-5266-4bcaf0671378","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж1 1126/17","name":"Кривично материјално право - кривично дело ометање овлашћеног службеног лица у обављању послова безбедности (члан 23. став 1. Закона о јавном реду и миру)","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-111","date":"17.10.2017","year":null},{"htmlUuid":"0e316b35-f12a-2250-239c-4eb6139f6bd7","courtName":"Виши суд у Новом Саду","subjectId":"Гж 2704/17","name":"Парнични поступак - стварна надлежност суда у поступку за утврђење недозвољености извршења","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-013","date":"16.10.2017","year":null},{"htmlUuid":"b2ace9c7-fd51-6867-7416-376c88e78f7e","courtName":"Виши суд у Новом Саду","subjectId":"Гж 4312/17","name":"Поступци извршења и обезбеђења - предлог за извршење на заложеној покретној ствари уписаној у регистар заложног права","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-028","date":"09.10.2017","year":null},{"htmlUuid":"cb8f5f73-497b-c97c-30a9-fb77b52486fe","courtName":"Апелациони суд у Крагујевцу","subjectId":"Кж1 1091/17","name":"Кривичн о процесно право - правни интерес жалбе у корист окривљеног","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-118","date":"06.10.2017","year":null},{"htmlUuid":"cf7d3226-d907-c219-1389-33011efcf1cc","courtName":"Виши суд у Новом Саду","subjectId":"Гж 4237/17","name":"Поступци извршења и обезбеђења - обрачун камате као веродостојна исправа","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-029","date":"03.10.2017","year":null},{"htmlUuid":"c3d84fc3-c740-d6b2-c396-524399cdbb72","courtName":"Апелациони суд у Новом Саду","subjectId":"Кж2 1058/17","name":"Кривично процесно право - надлежност суда за одлагање извршења казне по правноснажности решења којим је дозвољено понављање кривичног поступка","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-069","date":"02.10.2017","year":null},{"htmlUuid":"72bea33b-5e00-d0af-cfb1-9dfa808ded2f","courtName":"Апелациони суд у Новом Саду","subjectId":"Кж1 892/17 (1)","name":"Кривично материјално право - кривично дело тешко убиство на свиреп начин","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-075","date":"25.09.2017","year":null},{"htmlUuid":"29bcc3b5-6ba4-50ce-cb3f-d8d011d56141","courtName":"Апелациони суд у Новом Саду","subjectId":"Кж1 892/17","name":"Кривично материјално право - тешко убиство на подмукао начин","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-074","date":"25.09.2017","year":null},{"htmlUuid":"4d54a966-a566-482b-e854-574e26fba2a4","courtName":"Виши суд у Новом Саду","subjectId":"Гж 3875/17","name":"Поступци извршења и обезбеђења - привремена мера и вансудска хипотека","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-042","date":"21.09.2017","year":null},{"htmlUuid":"97f30f35-df39-a7fb-f31c-b61eb77017db","courtName":"Виши суд у Новом Саду","subjectId":"Гж 4013/17","name":"Поступци извршења и обезбеђења - извршење стране судске одлуке","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-032","date":"21.09.2017","year":null},{"htmlUuid":"dd0a55ce-3657-c397-d475-a3e2c4ea48dd","courtName":"Врховни касациони суд","subjectId":"Кзз 917/17 (1)","name":"Кривично процесно право - захтев за заштиту законитости у поступку за трајно одузимање имовине проистекле из кривичног дела","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-070","date":"19.09.2017","year":null},{"htmlUuid":"4802d67b-7b31-a8e0-0986-71428e73e1f4","courtName":"Виши суд у Новом Саду","subjectId":"Гж 3889/17","name":"Поступци извршења и обезбеђења - рок за подношење предлога за извршење, одлука у спору због сметање државине","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-027","date":"13.09.2017","year":null},{"htmlUuid":"9b7c1a03-aa69-a48e-0cdc-f14fcf905a44","courtName":"Апелациони суд у Новом Саду","subjectId":"Кж1 904/17","name":"Кривично процесно право - случајни докази","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-066","date":"11.09.2017","year":null},{"htmlUuid":"ce2995df-fcfc-8680-514c-44856660324f","courtName":"Апелациони суд у Новом Саду","subjectId":"Кж2 1106/17","name":"Кривично процесно право - субјективни елеменат кривичног дела приликом испитивања оптужнице","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-067","date":"10.09.2017","year":null},{"htmlUuid":"bbfd8c2f-8790-4f45-d9fd-8025b4690b21","courtName":"Апелациони суд у Новом Саду","subjectId":"Кж2 1106/17 (1)","name":"Кривично материјално право - условни отпуст","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-072","date":"10.09.2017","year":null},{"htmlUuid":"3b9dda50-85d9-cefb-c085-61dea3224dda","courtName":"Виши суд у Новом Саду","subjectId":"Гж1 115/17","name":"Радно право - одбачај тужбе због преклузије","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-058","date":"06.09.2017","year":null},{"htmlUuid":"67a87e10-f54b-af01-a2cf-50610f47b23d","courtName":"Апелациони суд у Крагујевцу","subjectId":"Р4 р 10/17","name":"Заштита права на суђење у разумном року, захтев за правично задовољење","issuer":"Билтен Апелационог суда у Крагујевцу","issuePage":"01/2018-167","date":"04.09.2017","year":null},{"htmlUuid":"51b84af9-1bb3-5877-ac8d-8a1ed2dbebb3","courtName":"Виши суд у Новом Саду","subjectId":"Гж 3601/17","name":"Поступци извршења и обезбеђења - одбијање предлога за противизвршење без ваљаних разлога","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-038","date":"31.08.2017","year":null},{"htmlUuid":"0911dd7d-a889-4b94-e70a-c9018d3a63ef","courtName":"Виши суд у Новом Саду","subjectId":"Гж 3564/17","name":"Поступци извршења и обезбеђења - накнада јавном извршитељу за лично достављање","issuer":"Билтен Вишег суда у Новом Саду","issuePage":"08/2017-037","date":"22.08.2017","year":null}]};
            //     this.result = responseLocal.result;
            // this.resultSize = responseLocal.resultSize;
            // for (var i = 0; i < this.result.length; i++) {
            //     this.result[i].timestamp = moment(this.result[i].date, 'DD.MM.YYYY').valueOf();
            // }


            const vm = this;
            var data = {
                act: (this.actId == '') ? null : this.actId,
                bk: (this.bodyQuery == '') ? null : this.bodyQuery,
                tk: (this.titleQuery == '') ? null : this.titleQuery,
                limit: this.resultLimit,
                essRule: (this.essRule == '') ? null : this.essRule,
                articles: (this.articles == '') ? null : this.articles,
                relLaw: (this.relLaw == '') ? null : this.relLaw,
                other: (this.contentType == 3),
                desc: (this.contentType == 1),
                resp: (this.contentType == 2),
                sent: (this.contentType == 0),
                up: (this.upisnici.length > 0) ? this.upisnik : null,
                opid: (this.contentType == 1) ? this.contentSubtype : -1,
                spid: (this.contentType == 0) ? this.contentSubtype : -1,
                pspid: this.contentSubtype,
                lega: this.legalAreaId,
                legs: this.legalSubjectId,
                legss: (this.legalSubjectId > 0) ? this.legalSubsubjectId : null,
                bn: (this.biltenIssue != -1) ? this.biltenIssue : null,
                bt: this.biltenType,
                ct: this.courtType,

                // df: this.dateFrom,
                // dt: this.dateTo,

                df: this.emitedDateFromVal,
                dt: this.emitedDateToVal,

                // Ova dva ne postoje na originalnom sajtu, ali postoje polja
                // d: this.department,
                // c: this.court,
            };

            axios.post(this.baseDIApiUrl + 'sp/advancedSearchBiltenSearch', data)
                .then(response => {
                    var data = response.data.result;

                    for (var i = 0; i < data.length; i++) {
                        data[i].timestamp = moment(data[i].date, 'DD.MM.YYYY').valueOf();
                    }

                    this.result = data;
                    this.resultSize = response.data.resultSize;
                    this.limit = response.data.limit;
                }).catch(function (error) {
                    console.log(error);
                    if (error.response.status === 401) {
                        // nije ulogovan
                        // otvori modal za logovanje
                        vm.$root.$emit('bv::show::modal', 'login-modal', '#btnShow')
                    }
                })
        },
        onReset: function () {
            this.courtType = -1;
            this.contentType = -1;
            this.contentSubtype = -1;
            this.court = -1;
            this.department = -1;
            this.upisnik = -1;
            this.biltenIssue = -1;
            this.biltenType = -1;
            this.legalAreaId = -1;
            this.legalSubjectId = -1;
            this.legalSubsubjectId = -1;
            this.publishingMethod = -1;

            this.actId = null;
            this.titleQuery = null;
            this.bodyQuery = null;
            this.essRule = null;
            this.articles = null;
            this.relLaw = null;
            this.dateFrom = null;
            this.dateTo = null;

            this.emitedDateFromVal = null;
            this.emitedDateToVal = null;

            this.resultLimit = 50;

            this.lastChanged = '';
            this.result = [];
            this.resultSize = null;
            this.$refs.dataPickerMask.resetDate();
        }
    },
    watch: {
        biltenType: function () {
            this.biltenIssue = -1;
            if (this.biltenType == -1 && this.lastChanged == 'bilten_type') {
                this.biltenIssues = [];
                this.courtTypes = this.allCourtTypes;
            } else if (this.biltenType != -1) {
                this.lastChanged = 'bilten_type';
                axios.get(this.baseSPApiUrl + 'Prins/biltenSearch/filter?bt=' + this.biltenType)
                    .then(response => {
                        this.courtType = -1;
                        this.courtTypes = response.data.courtTypes;
                    })

                axios.get(this.baseSPApiUrl + 'Prins/biltenSearch/biltenNumbers?bt=' + this.biltenType + '&ct=-1')
                    .then(response => {
                        this.biltenIssues = response.data
                    })
            }
        },
        courtType: function () {
            this.court = -1;
            this.upisnik = -1;
            this.courts = [];
            this.upisnici = [];
            if (this.courtType == -1 && this.lastChanged == 'court_type') {
                this.biltenTypes = this.allBiltenTypes;
            } else if (this.courtType != -1) {
                this.lastChanged = 'court_type';
                axios.get(this.baseSPApiUrl + 'Prins/courtsUp/4/' + this.courtType)
                    .then(response => {
                        this.courts = response.data.courts;
                        this.upisnici = response.data.up;
                    })

                axios.get(this.baseSPApiUrl + 'Prins/biltenSearch/filter?ct=' + this.courtType)
                    .then(response => {
                        this.biltenType = -1;
                        this.biltenTypes = response.data.biltenTypes;
                    })
            }
        },
        contentType: function () {
            this.contentSubtype = -1;

            if (this.contentType > -1 && this.contentType != 3) {
                var query = this.contentTypeQueries[this.contentType];
                axios.get(this.baseSPApiUrl + 'prins/4/contentSubtype?obrazlozenje=' + (query.obrazlozenje ? 'true' : 'false')
                    + '&sentenca=' + (query.sentenca ? 'true' : 'false')
                    + '&pravniStav=' + (query.pravniStav ? 'true' : 'false'))
                    .then(response => {
                        this.contentSubtypes = response.data;
                    });
            } else {
                this.contentSubtypes = [];
            }
        },
        court: function () {
            this.department = -1;
            if (this.court > -1) {
                axios.get(this.baseSPApiUrl + 'prins/departments/4/' + this.court)
                    .then(response => { this.departments = response.data });
            } else {
                this.departments = [];
            }
        },
        legalSubjectId: function () {
            this.legalSubsubjectId = -1;
            if (this.legalSubjectId > -1) {
                axios.get(this.baseSPApiUrl + 'prins/legalSubSubject/4/' + this.legalSubjectId)
                    .then(response => { this.legalSubsubjects = response.data })
            } else {
                this.legalSubsubjects = [];
            }
        },
    },
    beforeCreate: function () {
        document.body.className = 'color_supa';
    },
    mounted() {
        this.fetchFilterData();
    },
}
</script>

<style >
.table-bootstrap-vue thead tr th:nth-child(1) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(2) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(3) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(4) {
    width: 35%;
}

.table-bootstrap-vue thead tr th:nth-child(5) {
    width: 25%;
}

.table-bootstrap-vue thead tr th:nth-child(6) {
    width: 10%;
}
</style>
